import { render, staticRenderFns } from "./end-of-crouse.vue?vue&type=template&id=31bbba52&scoped=true"
import script from "./end-of-crouse.vue?vue&type=script&lang=js"
export * from "./end-of-crouse.vue?vue&type=script&lang=js"
import style0 from "./end-of-crouse.vue?vue&type=style&index=0&id=31bbba52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbba52",
  null
  
)

export default component.exports